import { render, staticRenderFns } from "./BaseBreadcrumbs.vue?vue&type=template&id=0998fc44&scoped=true"
import script from "./BaseBreadcrumbs.vue?vue&type=script&lang=ts"
export * from "./BaseBreadcrumbs.vue?vue&type=script&lang=ts"
import style0 from "./BaseBreadcrumbs.vue?vue&type=style&index=0&id=0998fc44&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0998fc44",
  null
  
)

export default component.exports